<app-message
    [successMessage]="false"
    [messageTitle]="'messages.identification-failed.title' | translate"
    [message]="'messages.identification-failed.description' | translate"
>
</app-message>
